import { StyleSheet, TextStyle } from 'react-native';
import theme from '../../../common/theme';
import { ThemeColors } from '../../../common/theme-colors';

export const getStyles = (colors: ThemeColors) => {
  const textStyle: TextStyle = {
    fontSize: 20,
    lineHeight: 28,
    color: colors.text,
    fontFamily: theme.fonts.semibold,
    fontVariant: ['tabular-nums'],
  };

  const textStyleMinor: TextStyle = {
    fontSize: 14,
    lineHeight: 20,
    color: colors.textLight,
    fontFamily: theme.fonts.regular,
    fontVariant: ['tabular-nums'],
  };

  return StyleSheet.create({
    container: {
      rowGap: 4,
      padding: 20,
      paddingTop: 30,
      borderWidth: 1,
      borderTopWidth: 0,
      borderColor: colors.border,
      backgroundColor: colors.elevation1,
      borderBottomLeftRadius: theme.radius.m,
      borderBottomRightRadius: theme.radius.m,
    },
    row: {
      flexDirection: 'row',
      columnGap: 16,
    },
    label: {
      ...textStyle,
      flex: 1,
    },
    value: {
      ...textStyle,
      textAlign: 'right',
    },
    labelMinor: {
      ...textStyleMinor,
      flex: 1,
    },
    valueMinor: {
      ...textStyleMinor,
      textAlign: 'right',
    },
  });
};
